/**
 * Basic entity Fallback service
 * Should be used when no specific service is found
 */
import { Injectable } from '@angular/core';
import { BaseService } from '../base';
import { ColDef } from 'ag-grid-community';

@Injectable()
export class BasicEntityService extends BaseService {
  public static ENTITY_TYPE: string = 'basic-entity';

  public headerNames: ColDef[] = [
    {
      headerName: 'Name',
      field: 'name',
      filter: false,
      cellStyle: { cursor: 'pointer' },
    },
  ];
}
